/* Items For powerfull section */
import Antenna from "../../../images/background/antena.png"
import Nut from "../../../images/background/nut.png"
import World from "../../../images/background/world.png"

export const performanceItems = [
  {
    image:World,
    title: ">470,000 homes",
    description: "served in our FTTH designs",
  },
  {
    image:Nut,
    title: ">500 miles",
    description: "of redline data analyzed & drafted",
  },
  {
    image:Antenna,
    title: ">500 miles",
    description:
      "of permits completed with a perfect safety record",
  },
];
